const cryptBytes = (dataBytes, keyStr) => {
  const key = new Uint8Array(32);
  let h = 5381;
  for (let i = 0; i < keyStr.length; i++) h = ((h << 5) + h + keyStr.charCodeAt(i)) >>> 0;
  for (let i = 0; i < 32; i++) {
    h = ((h << 5) + h + i) >>> 0;
    key[i] = h & 0xff;
  }
  const out = new Uint8Array(dataBytes.length);
  for (let i = 0; i < dataBytes.length; i++) {
    const k = key[i % 32];
    let x = dataBytes[i];
    x = ((x << 3) | (x >>> 5)) & 0xff;
    x = x ^ k;
    out[i] = x;
  }
  return out;
};

const bytesToStr = b => new TextDecoder().decode(b);
const base64ToBytes = s => Uint8Array.from(atob(s), c => c.charCodeAt(0));

export const decrypt = (base64Cipher, keyStr) => {
  return bytesToStr(cryptBytes(base64ToBytes(base64Cipher), keyStr));
};
